import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { DialogStateManager } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { ValueChip, ValueChipBody } from '@plato/ui/primitives/value-chip';
import { cn } from '@plato/ui/util/classes';
import { PlusIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
    EventCreateDialog,
    type EventCreateDialogProps,
} from '../../events/components/event-create-dialog.tsx';

export type Props = {
    day: string;
    ownerId: string;
    className?: string;
};

/**
 * A plus that creates an event on the given day; its label is for screen readers only. Hidden in a
 * colleague's calendar, where the header's disabled button already says that events can't be created.
 */
export function NewEventButton({ day, ownerId, className }: Props): ReactNode {
    const { t } = useTranslation('events');
    const { userId } = useAppConfig();

    if (ownerId !== userId) {
        return null;
    }

    const openCreateEvent = (): void => {
        void DialogStateManager.show(EventCreateDialog, {
            date: day,
            analyticsSource: 'calendar',
        } satisfies EventCreateDialogProps);
    };

    return (
        <ValueChip variant="suggestion" label={t('new_event_button')} className={cn('w-full', className)}>
            <ValueChipBody className="w-full justify-center" onClick={openCreateEvent}>
                <PlusIcon />
            </ValueChipBody>
        </ValueChip>
    );
}
